import React from 'react';
import { Box, Container, Heading, Text, Button, Flex } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FiArrowLeft, FiShield } from 'react-icons/fi';
import { useLegalLang } from '../LegalLangContext';

const PlatformNotFound = () => {
  const { t } = useLegalLang();
  return (
    <Container maxW="3xl" py={20} px={{ base: 4, md: 6 }}>
      <Flex direction="column" align="center" textAlign="center" gap={4}>
        <Flex
          boxSize="64px"
          borderRadius="full"
          bg="brand.50"
          color="brand.600"
          align="center"
          justify="center"
        >
          <FiShield size={28} />
        </Flex>
        <Heading as="h1" fontSize="2xl" color="text.primary">
          {t('notFoundTitle')}
        </Heading>
        <Text color="text.secondary" maxW="lg">
          {t('notFoundBody')}
        </Text>
        <Button
          as={RouterLink}
          to="/legal"
          colorScheme="brand"
          bg="brand.600"
          _hover={{ bg: 'brand.700' }}
          leftIcon={<FiArrowLeft />}
          mt={2}
        >
          {t('backToLegal')}
        </Button>
      </Flex>
    </Container>
  );
};

export default PlatformNotFound;
